<template>
  <div class="addressContent" v-if="isLogined">
    <div class="title">收货地址</div>
    <div class="deliveryAddress">
          <div><span>*</span>选择地区：</div>
          <select v-model="msg.province" placeholder="请选择省份"  @change="changeProvince(msg.province)" >
            <option v-for="item in provinces" :key="item.value" :label="item.name" :value="item.name" />
          </select>
          <select v-model="msg.city" placeholder="请选择城市"  @change="changeCity(msg.city)" >
            <option v-for="item in cities" :key="item.value" :label="item.name" :value="item.name" />
          </select>
          <select v-model="msg.area" placeholder="请选择县/区" >
            <option v-for="item in areas" :key="item.value" :label="item.name" :value="item.name" />
          </select>
    </div>
    <div class="deliveryAddressDetail"><div><span>*</span>详细地址：</div><textarea rows="2"  placeholder="请输入详细地址" v-model="msg.address"></textarea></div>
    <div class="deliveryName"><div><span>*</span>收货人姓名：</div><input type="text"  placeholder="请输入收货人姓名" v-model="msg.name"></div>
    <div class="deliveryMobile"><div><span>*</span>手机号码：</div><input type="text"  placeholder="请输入手机号码" v-model="msg.mobile">  <div style="float:clear;margin-top:5px;"></div></div>
    <div class="deliveryDefault" >     
          <el-checkbox v-model="msg.isDefault">设置默认收货地址</el-checkbox>      
    </div>  
    <div class="deliverySaveBtn"> <input type="button" value="保存" @click="save"></div>
    <div class="deliveryAddressList"> 
      <table v-if="addList.length>0">
        <tr class="addressHead">
          <th class="name">收货人</th>
          <th class="location">所在地区</th>
          <th class="address">详细地址</th>
          <th class="mobile">手机</th>
          <th>操作</th>
        </tr>
        <tr v-for="(item,i) in addList" :key="i">
          <td>{{item.name}}</td>
          <td>{{item.province}}{{item.city}}{{item.area}}</td>
          <td>{{item.address}}</td>
          <td>{{item.mobile}}</td>
          <td>
            <input type="button" v-if="item.isDefault" class="DefaultAddress" value="默认地址">
            <input type="button" v-else class="DefaultAddress1" value="设置默认" @click="changeDef(item)" >
            <br/>
            <div><span class="edit" @click="update(item)">修改</span>|<span class="del" @click="del(item.id)">删除</span></div>
          </td>
        </tr>
      </table>
      <img v-else src="http://img.static.knnnj.com/Default/dcb7cc98-a007-4f37-88cc-539fdaf24747.png" />
    </div>   
  </div>
  <div class="addressContent1" v-else >
    <div @click="toLogin()">亲,请先登陆</div>
  </div>
</template>
<style>
@import '../../styles/address.css';
</style>
<script>
  import api from '@/api'
  import { getAddressList, createOrEdit, Delete } from '@/api/deliveryAddress'
  import { getAreas} from '@/api/commonLookup' 
  import { mapState} from 'vuex'
  export default {
    data () {
      return {
        addList: [],    
        msg: {
          id: '',
          area:'',
          city:'',
          province:'',
          name: '',
          mobile: '',
          address: '',
          isDefault: false
        },
        provinces: [],
        cities: [],
        areas: [],
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: { 
      toLogin() {
        this.$router.push({ name: 'userLogin' })
      },
      message (m) {
        this.$message.error({
          message: m
        })
      },
      async _addressList () {
        await getAddressList().then(res => {
          if (res.data.success === true) {
            this.addList = res.data.result
          } else {
           this.addList = []
          }
        }).catch(error => {
            this.addList = []
        })
      },
      async _addressAddOrUpdate (params) {
       await createOrEdit(params).then(res => {
          if (res.data.success === true) {
            this.$message({ message: '操作成功',type: 'success',customClass: 'c-msg'})
            this._addressList()
            this.update();
          } else {
            this.message(res.message)
          }
        })
      },
      changeDef (item) {
        if (!item.isDefault) {
          item.isDefault = true
          this._addressAddOrUpdate(item)

        }
        return false
      },
      // 保存
      save () {
        let p = this.msg    
        if(p.province=='') 
        {
           this.$message({ message: '请选择省份', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.city==''||p.city==undefined) 
        {
           this.$message({ message: '请选择城市', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.area==''||p.area==undefined) 
        {
           this.$message({ message: '请选择县/区', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.address==''||p.address==undefined) 
        {
           this.$message({ message: '详细地址不可为空', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.name==''||p.name==undefined) 
        {
           this.$message({ message: '收货人姓名不可为空', type: 'error', customClass: 'c-msg' })
           return;
        }
        if(p.mobile==''||p.mobile==undefined) 
        {
           this.$message({ message: '手机号码不可为空', type: 'error', customClass: 'c-msg' })
           return;
        }
        var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if(!myreg.test(p.mobile))
        {
           this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
           return;
        }
        if (p.id) {
          this._addressAddOrUpdate(p)
        } else {
          p.id = 0;
          this._addressAddOrUpdate(p)
        }
      },
      // 删除
       del (id) {
        this.$confirm('确定删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
        }).then((res) => {
           Delete({id:id}).then(res => {
            this.$message({
                message: '删除成功',
                type: 'success',
                customClass: 'c-msg'
              })
           this._addressList()
          })
        })        
        
      },
      // 修改
      update (item) {
        if (item) {        
          this.msg.name = item.name
          this.msg.mobile = item.mobile
          this.msg.address = item.address
          this.msg.isDefault = item.isDefault
          this.msg.id = item.id
          this.msg.area = item.area
          this.msg.city = item.city
          this.msg.province = item.province
          this.changeProvinceAndCity(item.province,item.city);
         
        } else {
          this.msg.name = ''
          this.msg.mobile = ''
          this.msg.address = ''
          this.msg.isDefault = false
          this.msg.id = ''
          this.msg.area = ''
          this.msg.city = ''
          this.msg.province = ''
        }
      },
      async changeProvinceAndCity(province, city) {
        let item = this.provinces.find((p) => p.name == province)
        if (item) {     
        getAreas({ id: item.value }).then((res) => {   
            this.cities = res.data.result.items
            var item1 = this.cities.find((p) => p.name == city)
            if(item1)
            {
              getAreas({ id: item1.value }).then((res1) => {      
                 this.areas = res1.data.result.items
              })     
            }
          })        
        } else {
          this.cities = []
        }      
    },
      async changeProvince(province) {
        let item = this.provinces.find((p) => p.name == province)
        if (item) {     
        getAreas({ id: item.value }).then((res) => {   
            this.cities = res.data.result.items
          })        
        } else {
          this.cities = []
        }
        this.areas = []
        this.msg.city = undefined
        this.msg.area = undefined
    },   
    async changeCity(city) {
        let item = this.cities.find((p) => p.name == city)
        if (item) {
          getAreas({ id: item.value }).then((res) => {      
            this.areas = res.data.result.items
          })           
        } else {
          this.areas = []
        }
        this.msg.area = undefined
    },

    },
    created () {
     if(this.isLogined) 
     {
        getAreas({id:null}).then((response) => {      
          this.provinces = response.data.result.items
        })
        this._addressList()
     }
    },
    mounted() {
     
    }
  }
</script>


// WEBPACK FOOTER //
// addressList.vue?6c8f68cc